import React from 'react';
import { Checkbox as MaterialUiCheckbox, CheckboxProps } from '@mui/material';
import { ISharedFormProps } from '../ISharedFormProps';
import { ISharedProps } from '../../tools/ISharedProps';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import {
  CheckboxIndeterminate,
  CheckboxSelected,
  Checkbox as CheckboxIcon,
} from '~/Components/Icons';

interface ICheckboxProps extends CheckboxProps, ISharedProps, ISharedFormProps {}

const useStyles = makeStyles(() => ({
  indeterminate: {
    color: PRIMARY_BLUE,
  },
}));

export const Checkbox = ({ ...props }: ICheckboxProps) => {
  const { classes } = useStyles();

  return (
    <MaterialUiCheckbox
      color="primary"
      value={props.field?.value}
      name={props.field?.name}
      onChange={props.field?.onChange}
      onBlur={props.field?.onBlur}
      icon={<CheckboxIcon />}
      indeterminateIcon={<CheckboxIndeterminate />}
      checkedIcon={<CheckboxSelected />}
      classes={{ indeterminate: classes.indeterminate }}
      {...props}
    />
  );
};
